
import {Link, LinkProps} from 'react-router-dom';
import clsx from 'clsx';
import React, {useMemo} from 'react';
import { LiveEvent } from "@app/admin/live-events/interfaces/live-event";
import { getBootstrapData } from "@ui/bootstrap-data/bootstrap-data-store";

interface LiveEventLinkProps extends Omit<LinkProps, 'to'> {
  liveEvent: LiveEvent;
  className?: string;
}
export function LiveEventLink({
  liveEvent,
  className,
  ...linkProps
}: LiveEventLinkProps) {
  const finalUri = useMemo(() => {
    return getLiveEventLink(liveEvent);
  }, [liveEvent]);

  return (
    <Link
      {...linkProps}
      className={clsx('hover:underline', className)}
      to={finalUri}
    >
      {liveEvent.name}
    </Link>
  );
}

export function getLiveEventLink(
  liveEvent: LiveEvent,
  {absolute}: {absolute?: boolean} = {},
): string {
  let link = `/live-event/${liveEvent.slug}`;
  if (absolute) {
    link = `${getBootstrapData().settings.base_url}${link}`;
  }
  return link;
}